var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2234 0.95752H1.77187C0.792187 0.95752 0 1.73096 0 2.68721V23.2231C0 24.1794 0.792187 24.9575 1.77187 24.9575H22.2234C23.2031 24.9575 24 24.1794 24 23.2278V2.68721C24 1.73096 23.2031 0.95752 22.2234 0.95752ZM7.12031 21.4091H3.55781V9.95283H7.12031V21.4091ZM5.33906 8.39189C4.19531 8.39189 3.27188 7.46846 3.27188 6.32939C3.27188 5.19033 4.19531 4.26689 5.33906 4.26689C6.47813 4.26689 7.40156 5.19033 7.40156 6.32939C7.40156 7.46377 6.47813 8.39189 5.33906 8.39189ZM20.4516 21.4091H16.8937V15.8403C16.8937 14.5138 16.8703 12.8028 15.0422 12.8028C13.1906 12.8028 12.9094 14.2513 12.9094 15.7466V21.4091H9.35625V9.95283H12.7687V11.5185H12.8156C13.2891 10.6185 14.4516 9.66689 16.1813 9.66689C19.7859 9.66689 20.4516 12.0388 20.4516 15.1231V21.4091Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLinkedin);
export default __webpack_public_path__ + "static/media/icon-linkedin.feee17df71c6022da814cf64a3d1c02d.svg";
export { ForwardRef as ReactComponent };